import { render } from "./ProductLogisticDetailsSection2.vue?vue&type=template&id=13d4b613&scoped=true"
import script from "./ProductLogisticDetailsSection2.vue?vue&type=script&lang=js"
export * from "./ProductLogisticDetailsSection2.vue?vue&type=script&lang=js"

import "./ProductLogisticDetailsSection2.vue?vue&type=style&index=0&id=13d4b613&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d4b613"]])

export default __exports__